<template>
  <div class="damaged-toolbar-root">
    <div
      class="bg-red-darken-3 damaged-toolbar-strip pt-2 pb-2 pb-md-3 px-3 px-md-6 px-lg-8"
    >
      <v-row
        align="center"
        class="damaged-toolbar-search-row flex-wrap"
        no-gutters
      >
        <v-col
          cols="auto"
          class="d-none d-md-flex align-center flex-shrink-0 damaged-toolbar-brand ga-3"
        >
          <div class="text-subtitle-1 text-white text-truncate">
            {{ $t("parts.damaged_parts.label") }}
          </div>
          <v-divider class="flex-shrink-0" inset vertical />
        </v-col>

        <v-spacer class="d-none d-md-flex" />

        <v-col cols="12" md="auto" class="damaged-toolbar-right flex-grow-1 min-width-0">
          <div
            class="d-flex flex-wrap align-center ga-2 ga-md-3 w-100 justify-start justify-md-end"
          >
            <v-btn
              color="grey-darken-4"
              variant="flat"
              class="flex-shrink-0 damaged-toolbar-export-btn"
              :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
              @click="exportToExcel"
            >
              {{ $t("parts.damaged_parts.export") }}
              <v-icon end>mdi-file-excel-outline</v-icon>
            </v-btn>

            <div class="damaged-toolbar-fields flex-grow-1 min-width-0">
              <v-autocomplete
                v-if="searchType === 'title'"
                v-model="titleCode"
                v-model:search="searchTitle"
                v-model:menu="menuOpen"
                :loading="loadingTitle"
                :items="titles"
                :label="$t('parts.inventory.search')"
                item-value="partCode"
                :item-title="() => ''"
                :custom-filter="customFilter"
                variant="solo"
                color="grey-darken-4"
                append-inner-icon="mdi-magnify"
                single-line
                hide-details
                hide-no-data
                clearable
                autocomplete="off"
                class="damaged-field-on-red"
                @keyup.enter="searchMethod"
                @click:append-inner="searchMethod"
                @update:search="updateSearch"
              >
          <template #item="{ item, props }">
            <v-list-item
              v-bind="props"
              class="listRowColor"
              @click="selectCode(item)"
            >
              <!-- Main Title -->
              <div class="text-start pa-2">
                <span class="caption">Info Car - </span>
                <span
                  class="font-weight-bold"
                  v-html="
                    highlight(
                      item?.raw?.title?.[$store.getters.language] || 'No Title',
                      searchTitle,
                    )
                  "
                />
              </div>

              <!-- Related Titles (Limit to a few to avoid excessive rendering) -->
              <div
                v-if="item?.raw?.related?.length"
                class="related-scroll hidden-sm-and-down pa-2"
              >
                <span
                  v-for="(el, idx) in item.raw.related"
                  :key="idx"
                  class="mr-2"
                  style="font-size: 10px"
                  v-html="
                    highlight(
                      el?.title?.[$store.getters.language] ||
                        'No Related Title',
                      searchTitle,
                    )
                  "
                />
              </div>
            </v-list-item>
          </template>
          <template #selection="{ item }">
            <span v-if="item">
              {{ item?.raw?.title?.[$store.getters.language] }}
            </span>
          </template>
        </v-autocomplete>

              <!--SEARCH BY MULTIPLE TITLES-->
              <v-autocomplete
                v-else-if="searchType === 'multipleTitles'"
                v-model="selectedGroup"
                v-model:search="searchMultipleTitles"
                v-model:menu="menuMultipleOpen"
                :loading="loadingMultipleTitles"
                :items="titleGroups"
                :label="$t('parts.movements.search')"
                :item-title="`title.${$store.getters.language}`"
                item-value="_id"
                variant="solo"
                color="grey-darken-4"
                append-inner-icon="mdi-magnify"
                single-line
                hide-details
                hide-no-data
                return-object
                class="damaged-field-on-red"
                @update:model-value="onGroupSelected"
                @keyup.enter="searchMethod()"
                @click:append-inner="searchMethod()"
              />

              <!--SEARCH OTHER FIELDS-->
              <v-text-field
                v-else
                v-model="search"
                :label="$t('parts.damaged_parts.search')"
                flat
                variant="solo"
                color="grey-darken-4"
                append-inner-icon="mdi-magnify"
                single-line
                hide-details
                class="damaged-field-on-red"
                @keyup.enter="searchMethod()"
                @click:append-inner="searchMethod()"
              />
            </div>

            <v-select
              v-model="searchType"
              :items="searchTypes"
              item-title="label"
              item-value="value"
              color="grey-darken-4"
              variant="solo"
              flat
              hide-details
              class="damaged-field-on-red damaged-toolbar-type-select mt-2 mt-md-0 flex-shrink-0"
            />

            <v-btn
              color="grey-darken-4"
              size="small"
              variant="flat"
              class="mt-2 mt-md-0 flex-shrink-0 damaged-toolbar-advanced-btn"
              @click="advancedSearch = !advancedSearch"
            >
              <v-icon start>
                {{
                  advancedSearch
                    ? "mdi-checkbox-marked-outline"
                    : "mdi-checkbox-blank-outline"
                }}
              </v-icon>
              {{ $t("parts.inventory.advanced") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="redColor pa-3 pa-md-4">
      <!--------------------------------------ADVANCED SEARCH-------------------------------------->
      <div v-if="advancedSearch" class="damaged-advanced-search-panel">
        <v-form ref="form" lazy-validation>
          <v-row class="damaged-advanced-search-grid pb-2 px-2 px-sm-4 flex-wrap align-center">
            <!--NO APPLICABILITY DROPDOWN-->
            <v-col v-if="advancedSearch && noApplicabilityDropdown" cols="12">
              <v-row class="ma-2 d-flex flex-wrap align-center ga-4">
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    v-model="advancedSearchItems.noApplicability"
                    :label="$t('parts.advanced_search.no_applicability')"
                    hide-details
                    color="grey-lighten-4"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    v-model="advancedSearchItems.noNotes"
                    :label="$t('parts.advanced_search.no_notes')"
                    hide-details
                    color="grey-lighten-4"
                  />
                </v-col>
              </v-row>
            </v-col>
            <!---------------------------------------DIVIDER--------------------------------------->
            <v-col cols="12" lg="12" md="12" xl="12">
              <v-row
                no-gutters
                align="center"
                justify="center"
                class="damaged-advanced-divider-row mt-2 mb-1 mx-1"
              >
                <v-divider
                  class="flex-grow-1 d-none d-sm-flex"
                  style="border-width: 1px; border-color: white; opacity: 100"
                />

                <div
                  class="damaged-advanced-divider-label mx-2 mx-sm-4 px-1 text-white font-weight-medium text-center text-subtitle-1 text-md-h5"
                >
                  {{ $t("parts.advanced_search.car_details") }}
                </div>
                <v-divider
                  class="flex-grow-1 d-none d-sm-flex"
                  style="border-width: 1px; border-color: white; opacity: 100"
                />
              </v-row>
            </v-col>
            <!----------------------------------------PLATE---------------------------------------->
            <v-col cols="12" sm="3" lg="4">
              <v-tooltip v-if="!canSearchPlates" location="top">
                <template #activator="{ props }">
                  <div
                    v-bind="props"
                    class="plate-wrapper"
                    style="position: relative"
                  >
                    <v-text-field
                      v-model="plate"
                      flat
                      variant="solo"
                      maxlength="7"
                      :loading="loadingPlate"
                      :disabled="!canSearchPlates"
                      :color="foundPlate ? 'success' : 'error'"
                      :label="
                        $t('parts.advanced_search.plate') +
                        ' ' +
                        examplePlateFormat
                      "
                      hide-details
                      :append-inner-icon="
                        foundPlate
                          ? 'mdi-check-circle-outline'
                          : 'mdi-alert-circle-outline'
                      "
                      autocomplete="off"
                    />
                  </div>
                </template>

                <span
                  ><v-icon color="warning">mdi-alert-outline</v-icon>
                  {{ $t("plate_search_disabled_message") }}</span
                >
              </v-tooltip>
              <div v-else style="position: relative">
                <v-text-field
                  v-model="plate"
                  flat
                  variant="solo"
                  maxlength="7"
                  :loading="loadingPlate"
                  :disabled="!canSearchPlates"
                  :color="foundPlate ? 'success' : 'error'"
                  :label="
                    $t('parts.advanced_search.plate') + ' ' + examplePlateFormat
                  "
                  hide-details
                  :append-inner-icon="
                    foundPlate
                      ? 'mdi-check-circle-outline'
                      : 'mdi-alert-circle-outline'
                  "
                  autocomplete="off"
                  @keyup.enter="searchPlate()"
                  @click:append-inner="searchPlate()"
                  @input="formatPlate"
                  @focus="showDropdown = true"
                  @blur="onBlur"
                />
                <div
                  v-if="showDropdown && lastFivePlates.length"
                  class="plates-dropdown"
                  style="
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    background: white;
                    border: 1px solid #ccc;
                    z-index: 10;
                    max-height: 200px;
                    overflow-y: auto;
                  "
                >
                  <div
                    v-for="(p, index) in lastFivePlates"
                    :key="index"
                    class="plate-item"
                    style="padding: 8px; cursor: pointer"
                    :style="{
                      background: hovered === index ? '#eee' : 'white',
                    }"
                    @mousedown.prevent="selectPlate(p)"
                    @mouseover="hovered = index"
                  >
                    {{ p.toUpperCase() }}
                  </div>
                </div>
              </div>

              <!-- <v-text-field
                v-model="plate"
                flat
                variant="solo"
                return-masked-value
                :disabled="!canSearchPlates"
                :color="foundPlate ? 'success': 'error'"
                :label="$t('parts.advanced_search.plate') + ' ' + examplePlateFormat"
                :loading="loadingPlate"
                class="ml-2 mr-2 mt-2 custom-loader"
                hide-details
                :append-inner-icon="foundPlate ? 'check_circle': 'error'"
                @keyup.enter="searchPlate()"
                @click:appendInner="searchPlate()"
                @input="formatPlate"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    v-if="loadingPlate"
                    color="red"
                    indeterminate
                  />
                </template>
              </v-text-field> -->
            </v-col>
            <!----------------------------------------BRAND---------------------------------------->
            <v-col cols="12" sm="7" lg="4">
              <v-autocomplete
                v-model="brand"
                autocomplete="off"
                :items="brands"
                :loading="loadingBrand"
                :label="$t('parts.advanced_search.brand')"
                item-title="title"
                flat
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
                @click:append-inner="brand = null"
              >
                <!-- Custom dropdown item -->
                <template #item="{ props, item }">
                  <v-list-item v-bind="props">
                    <template #prepend>
                      <v-img
                        :src="item.raw.logo"
                        height="35"
                        width="35"
                        class="mr-3"
                        cover
                      />
                    </template>
                    <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
                  </v-list-item>
                </template>

                <!-- Selected value in the field -->
                <template #selection="{ item }">
                  <div class="d-flex align-center">
                    <v-img
                      :src="item.raw.logo"
                      height="35"
                      width="35"
                      class="mr-3"
                      cover
                    />
                    <span>{{ item.raw.title }}</span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <!----------------------------------------YEAR----------------------------------------->
            <v-col cols="12" sm="2" lg="4">
              <v-text-field
                v-model="year"
                :label="$t('parts.advanced_search.year')"
                :rules="[yearRule]"
                flat
                variant="solo"
                type="number"
                :max="new Date().getFullYear()"
                oninput="validity.valid || (value = new Date().getFullYear())"
                color="red-darken-1"
                hide-details
              />
            </v-col>
            <!----------------------------------------MODEL---------------------------------------->
            <v-col cols="12" sm="8" xl="5" lg="4">
              <v-combobox
                v-model="model"
                autocomplete="off"
                :items="models"
                :loading="loadingModel"
                :label="!model ? $t('parts.advanced_search.model') : ''"
                item-title="description"
                item-value="modelCode"
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
                class="car-search-combobox"
                @click:append-inner="model = null"
              >
                <!-- Dropdown items -->
                <template #item="{ props, item }">
                  <v-list-item v-bind="props">
                    <v-list-item-content>
                      <v-row>
                        <!-- Description -->
                        <v-col cols="12" md="4" class="bg-grey-lighten-3 mt-2">
                          <div class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.model")
                            }}</span>
                            <span class="font-weight-bold">{{
                              item.raw.description
                            }}</span>
                          </div>
                        </v-col>

                        <!-- Year range -->
                        <v-col
                          cols="12"
                          md="8"
                          class="bg-grey-lighten-3 mt-2"
                        >
                          <div class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.year")
                            }}</span>
                            <span class="font-weight-bold">
                              {{ formatMonthYear(item.raw.startingDate) }} -
                              {{ formatMonthYear(item.raw.endingDate) }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <!-- Selected value -->
                <template #selection="{ item }">
                  <div
                    class="car-detail-selection d-flex justify-between align-center pa-2 w-100"
                  >
                    <div class="car-detail-col d-flex flex-column pr-2">
                      <span class="caption">{{
                        $t("parts.advanced_search.model")
                      }}</span>
                      <span class="font-weight-bold">{{
                        item.raw.description
                      }}</span>
                    </div>
                    <div class="car-detail-col d-flex flex-column">
                      <span class="caption">{{
                        $t("parts.advanced_search.year")
                      }}</span>
                      <span class="font-weight-bold">
                        {{ formatMonthYear(item.raw.startingDate) }} -
                        {{ formatMonthYear(item.raw.endingDate) }}
                      </span>
                    </div>
                  </div>
                </template>
              </v-combobox>
            </v-col>
            <!---------------------------------------ENGINE---------------------------------------->
            <v-col cols="12" sm="4" xl="4" lg="4">
              <!--------------------------------------SUPPLY--------------------------------------->
              <v-row class="d-block ml-0 ml-sm-2 flex-column">
                <div class="subheading text-white">
                  {{ $t("parts.advanced_search.supply.supply") }}
                </div>
                <v-radio-group
                  v-model="supply"
                  class="ma-0"
                  inline
                  hide-details
                >
                  <v-radio
                    color="grey-lighten-4"
                    :label="supplies[0].title"
                    :value="supplies[0].code"
                  />
                  <v-radio
                    color="grey-lighten-4"
                    :label="supplies[1].title"
                    :value="supplies[1].code"
                  />
                  <v-radio
                    color="grey-lighten-4"
                    :label="supplies[2].title"
                    :value="supplies[2].code"
                  />
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4" xl="4" lg="4">
              <v-autocomplete
                v-model="engine"
                autocomplete="off"
                :items="versions"
                :loading="loadingVersion"
                :label="$t('parts.advanced_search.engine')"
                item-title="engineCode"
                flat
                variant="solo"
                color="red-darken-1"
                hide-details
                clearable
                @click:append-inner="
                  engine = null;
                  version = null;
                  if (model) getVersions(model.brandCode, model.modelCode);
                "
              />
            </v-col>
            <!---------------------------------------VERSION--------------------------------------->
            <v-col cols="12" xl="12" lg="12" md="12">
              <v-combobox
                v-model="version"
                autocomplete="off"
                :items="versions"
                :loading="loadingVersion"
                :label="!version ? $t('parts.advanced_search.version') : ''"
                item-title="fullDescription"
                item-value="versionCode"
                flat
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
                class="car-search-combobox car-search-version-combobox"
                @click:append-inner="version = null"
              >
                <!-- Dropdown items -->
                <template #item="{ item, props }">
                  <v-list-item v-bind="props">
                    <div
                      class="d-sm-none car-version-detail-item bg-grey-lighten-3 mt-2 pa-3 w-100"
                    >
                      <div
                        class="car-version-detail-row car-version-detail-row--dropdown"
                      >
                        <div
                          class="car-version-detail-col car-version-detail-col--main"
                        >
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </div>
                        <div class="car-version-detail-col">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </div>
                        <div class="car-version-detail-col">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </div>
                        <div class="car-version-detail-col">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                          </span>
                        </div>
                        <div class="car-version-detail-col">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </div>
                        <div class="car-version-detail-col">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>&nbsp;
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <v-row class="d-none d-sm-flex pa-3 bg-grey-lighten-3 mt-2">
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>

                <!--SELECTED-->
                <template #selection="{ item }">
                  <div class="car-version-detail-selection car-detail-selection w-100 d-sm-none">
                    <div class="car-version-detail-row">
                      <div
                        class="car-version-detail-col car-version-detail-col--main"
                      >
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                        </span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <v-row class="pa-2 d-none d-sm-flex">
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-combobox>
            </v-col>
            <!---------------------------------------DIVIDER--------------------------------------->
            <v-col cols="12" lg="12" md="12" xl="12">
              <v-row
                no-gutters
                align="center"
                justify="center"
                class="damaged-advanced-divider-row mt-2 mb-1 mx-1"
              >
                <v-divider
                  class="flex-grow-1 d-none d-sm-flex"
                  style="border-width: 1px; border-color: white; opacity: 100"
                />

                <div
                  class="damaged-advanced-divider-label mx-2 mx-sm-4 px-1 text-white font-weight-medium text-center text-subtitle-1 text-md-h5"
                >
                  {{ $t("parts.advanced_search.part_details") }}
                </div>
                <v-divider
                  class="flex-grow-1 d-none d-sm-flex"
                  style="border-width: 1px; border-color: white; opacity: 100"
                />
              </v-row>
            </v-col>
            <!------------------------------------INSTITUTIONS------------------------------------->
            <v-col
              v-if="
                $store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'LekoEmployee' ||
                $store.getters.role === 'SuperAdmin'
              "
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              class="mt-0 mb-0 pt-0 pb-0"
            >
              <v-autocomplete
                v-model="advancedSearchItems.institution"
                autocomplete="off"
                :items="institutions"
                :loading="loadingInstitution"
                :label="$t('parts.advanced_search.institution')"
                :hint="$t('parts.advanced_search.institution')"
                persistent-hint
                clearable
                item-title="title"
                item-value="_id"
                flat
                variant="solo"
                color="red-darken-1"
              />
            </v-col>
            <!--------------------------------------SHIPMENTS-------------------------------------->

            <v-col
              cols="12"
              :sm="
                $store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'LekoEmployee' ||
                $store.getters.role === 'SuperAdmin'
                  ? 6
                  : 12
              "
              lg="3"
              xl="2"
            >
              <v-autocomplete
                v-model="advancedSearchItems.shipment"
                autocomplete="off"
                :items="shipments"
                :loading="loadingShipment"
                :label="$t('parts.advanced_search.shipment')"
                :hint="$t('parts.advanced_search.shipment')"
                persistent-hint
                item-title="name"
                item-value="_id"
                flat
                variant="solo"
                color="red-darken-1"
              />
            </v-col>
            <!----------------------------------------PRICE---------------------------------------->
            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
              <v-combobox
                v-model="advancedSearchItems.price[0]"
                :items="prices"
                flat
                variant="solo"
                :label="$t('parts.inventory.from')"
                :hint="$t('parts.inventory.from')"
                persistent-hint
                color="red-darken-1"
                prepend-icon="mdi-currency-eur"
                type="number"
                oninput="validity.valid || (value = '')"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
              <v-combobox
                v-model="advancedSearchItems.price[1]"
                :items="prices"
                variant="solo"
                :label="$t('parts.inventory.upto')"
                :hint="$t('parts.inventory.upto')"
                persistent-hint
                flat
                color="red-darken-1"
                prepend-icon="mdi-currency-eur"
                type="number"
                oninput="validity.valid || (value = '')"
              />
            </v-col>
            <!----------------------------------------DATE----------------------------------------->
            <!-- STARTING DATE -->
            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="advancedSearchItems.startDate"
                    :value="formatDateToDisplay(advancedSearchItems.startDate)"
                    :label="$t('parts.advanced_search.starting_date')"
                    :hint="$t('parts.advanced_search.select_starting_date')"
                    variant="solo"
                    flat
                    color="black"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  v-model="advancedSearchItems.startDate"
                  color="red-darken-3"
                  :max="advancedSearchItems.endDate || null"
                  @update:model-value="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <!-- ENDING DATE -->
            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="advancedSearchItems.endDate"
                    :value="formatDateToDisplay(advancedSearchItems.endDate)"
                    :label="$t('parts.advanced_search.ending_date')"
                    :hint="$t('parts.advanced_search.select_ending_date')"
                    variant="solo"
                    flat
                    color="black"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  v-model="advancedSearchItems.endDate"
                  color="red-darken-3"
                  :min="advancedSearchItems.startDate || null"
                  @update:model-value="endDateMenu = false"
                />
              </v-menu>
            </v-col>

            <!---------------------------------------STATUS---------------------------------------->
            <v-col cols="12" xs="12" class="pa-2 d-md-none">
              <div class="subheading text-white mt-2 mb-2">
                {{ $t("parts.advanced_search.select_status") }}
              </div>
              <v-select
                v-model="advancedSearchItems.status"
                :items="statusItems"
                item-title="title"
                item-value="value"
                multiple
                chips
                closable-chips
                hide-details
                density="compact"
                variant="outlined"
                bg-color="red-darken-3"
                class="mt-1"
              />
            </v-col>
            <v-col cols="12" xs="12" sm="6" class="pa-2 d-none d-md-block">
              <div class="subheading text-white mt-2 mb-2">
                {{ $t("parts.advanced_search.select_status") }}
              </div>
              <v-row class="flex-wrap pl-0 pl-sm-3">
                <v-col
                  v-for="(status, index) in statusItems"
                  :key="index"
                  cols="12"
                  xs="12"
                  sm="6"
                  class="my-0 py-0 d-flex"
                >
                  <v-checkbox
                    v-model="advancedSearchItems.status"
                    :label="status.title"
                    :value="status.value"
                    dark
                    hide-details
                    class="ma-0 pa-0"
                    color="grey-lighten-4"
                  />
                </v-col>
              </v-row>
            </v-col>
            <!---------------------------------------QUALITY--------------------------------------->
            <v-col cols="12" xs="12" sm="6" class="pa-2 d-md-none">
              <QualityRatingSelect
                :model-value="selectedQualityRating"
                :label="$t('parts.advanced_search.select_quality')"
                label-class="text-white mt-2 mb-2"
                caption-class="text-grey-lighten-2"
                clear-button-color="grey-lighten-2"
                :size="32"
                @update:model-value="onQualityRatingSelect"
              />
            </v-col>
            <v-col cols="12" xs="12" sm="6" class="pa-2 d-none d-md-block">
              <div class="subheading text-white mt-2 mb-2">
                {{ $t("parts.advanced_search.select_quality") }}
              </div>
              <v-row class="flex-wrap">
                <v-col
                  v-for="(quality, index) in qualityItems"
                  :key="index"
                  cols="12"
                  xs="12"
                  sm="6"
                  class="my-0 py-0 d-flex"
                >
                  <span>
                    <v-checkbox
                      v-model="advancedSearchItems.quality"
                      :value="quality._id"
                      dark
                      hide-details
                      class="ma-0 pa-0"
                      color="grey-lighten-4"
                    >
                      <template #label>
                        <v-rating
                          v-model="quality.rating"
                          :color="
                            advancedSearchItems.quality.includes(quality._id)
                              ? 'yellow'
                              : 'grey'
                          "
                          small
                          :background-color="
                            advancedSearchItems.quality.includes(quality._id)
                              ? 'yellow'
                              : 'grey'
                          "
                          readonly
                        />
                      </template>
                    </v-checkbox>
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <!----------------------------------------------------------------------------------------->
        <v-row class="justify-center align-center pb-4 px-2 flex-wrap ga-2">
          <v-btn
            dark
            color="grey-darken-4"
            class="mx-1"
            @click="clearSearchFields"
          >
            {{ $t("parts.advanced_search.clear") }}
            <v-icon end> mdi-notification-clear-all </v-icon>
          </v-btn>
          <v-btn dark color="grey-darken-4" class="mx-1" @click="searchMethod">
            {{ $t("parts.advanced_search.search") }}
            <v-icon end> mdi-magnify </v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary */

import moment from "moment";
import * as XLSX from "xlsx";
import { useDisplay } from "vuetify";
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import QualityRatingSelect from "../common/QualityRatingSelect.vue";

export default {
  components: {
    QualityRatingSelect,
  },
  filters: {
    moment(date) {
      moment.locale(localStorage.getItem("language"));
      const valid = moment(date).isValid();
      if (valid) return moment(date).format("MM/YYYY");
      return "";
    },
  },
  props: ["items"],
  data: () => ({
    searchTypes: [
      { label: "Title", value: "title" },
      { lable: "Multiple Titles", value: "multipleTitles" },
      { label: "ID", value: "id" },
      { label: "Other", value: "other" },
    ],
    searchType: "title",
    advancedSearch: false,
    search: "",
    foundPlate: false,
    canSearchPlates: false,
    plate: null,
    searchTitle: null,
    searchMultipleTitles: null,
    titleCode: null,
    titleCodes: [],
    titles: [],
    brands: [],
    models: [],
    versions: [],
    titleGroups: [],
    brand: null,
    model: null,
    version: null,
    engine: null,
    year: null,
    yearRule: "",
    supply: null,
    supplies: [
      { code: "B", title: "Petrol" },
      { code: "D", title: "Diesel" },
      { code: "G", title: "LPG" },
    ],
    advancedSearchItems: {
      brand: null,
      model: null,
      version: null,
      institution: null,
      shipment: null,
      status: [7, 8, 8.1, 9],
      quality: [],
      price: [0, 50000],
      startDate: "",
      endDate: "",
    },
    statusItems: [
      { title: "Damaged-Inventory", value: 7 },
      { title: "Damaged-Sales", value: 8 },
      { title: "Damaged-Shop", value: 8.1 },
      { title: "Damaged-Lost", value: 9 },
    ],
    qualityItems: [],
    selectedQualityRating: 0,
    institutions: [],
    shipments: [],
    loadingTitle: false,
    loadingMultipleTitles: false,
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
    loadingQuality: false,
    loadingInstitution: false,
    loadingShipment: false,
    loadingPlate: false,
    startDateMenu: false,
    endDateMenu: false,
    prices: [],
    menuOpen: false,
    selectingItem: false,
    menuMultipleOpen: false,
    selectingItemCodes: false,
    examplePlateFormat: ": (DG853SV)",
    showDropdown: false,
    hovered: -1,
    logs: [],
    logsCount: null,
    lastFivePlates: [],
  }), // eslint-disable-line vue/require-prop-types
  computed: {
    display() {
      return useDisplay();
    },
  },
  watch: {
    search(value) {
      if (!value && this.advancedSearch === false) this.$emit("clear-search");
    },
    async searchTitle(newValue) {
      if (this.selectingItem) {
        this.selectingItem = false;
        return;
      }
      if (newValue) {
        if (this.selectingItem) {
          this.selectingItem = false;
          return;
        }
        this.loadingTitle = true;
        try {
          const response = await getRequest(
            "/info-car/parts",
            `title=${encodeURIComponent(newValue)}&language=${this.$store.getters.language}`,
          );
          this.titles = response.parts || [];
        } catch (error) {
          this.titles = [];
        } finally {
          this.loadingTitle = false;
          this.menuOpen = this.titles.length > 0;
        }
      } else {
        if (!this.titleCode) {
          if (!this.advancedSearch) this.$emit("clear-search");
          this.titles = [];
          this.menuOpen = false;
        } else {
          const selected = this.titles.find(
            (t) => t.partCode === this.titleCode,
          );
          if (selected) {
            this.selectingItem = true; // prevent re-trigger
            this.searchTitle =
              selected.title?.[this.$store.getters.language] || "";
            this.menuOpen = false;
          }
        }
      }
    },
    searchMultipleTitles(value) {
      if (value) {
        if (this.selectingItemCodes) {
          this.selectingItemCodes = false;
          return;
        }
        this.loadingMultipleTitles = true;
        getRequest(
          "/info-car/partgroups",
          `title=${value}&language=${this.$store.getters.language}`,
        )
          .then((response) => {
            this.titleGroups = response.partgroups;
          })
          .catch(() => {})
          .finally(() => {
            this.loadingMultipleTitles = false;
            if (!this.selectingItemCodes) {
              this.menuMultipleOpen = this.titleGroups.length > 0;
            }
          });
      } else {
        if (!this.titleCodes) {
          if (!this.advancedSearch) this.$emit("clear-search");
          this.titleCodes = [];
          this.menuMultipleOpen = false;
        } else {
          const selected = this.titleGroups.find(
            (t) => JSON.stringify(t.codes) === JSON.stringify(this.titleCodes),
          );
          if (selected) {
            this.selectingItemCodes = true; // prevent re-trigger
            this.searchMultipleTitles =
              selected.title?.[this.$store.getters.language] || "";
            this.menuMultipleOpen = false;
          }
        }
      }
    },
    advancedSearch(value) {
      if (!value) {
        this.advancedSearchItems = {
          brand: null,
          model: null,
          version: null,
          institution: null,
          shipment: null,
          status: [7, 8, 8.1, 9],
          quality: [],
          price: [0, 50000],
          startDate: "",
          endDate: "",
        };
        this.brands = [];
        this.models = [];
        this.versions = [];
        this.brand = null;
        this.model = null;
        this.version = null;
      } else {
        this.getQualities();
        this.getBrands();
        this.getInstitution();
        if (
          this.$store.getters.role === "LekoAdmin" ||
          this.$store.getters.role === "LekoEmployee" ||
          this.$store.getters.role === "SuperAdmin"
        ) {
          this.getInstitutions();
        } else {
          this.getShipments(this.$store.getters.institutionId);
        }
      }
    },
    "advancedSearchItems.institution": {
      handler(value) {
        if (value) this.getShipments(value);
      },
    },
    brand(value) {
      if (value) {
        this.models = [];
        this.model = null;
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the models if we are searching for a license plate.
        if (this.loadingPlate === false) this.getModels(value.brandCode);
        this.advancedSearchItems.brand = value.brandCode;
      } else {
        this.advancedSearchItems.brand = null;
      }
    },
    model(value) {
      if (typeof value === "string") {
        // Vuetify combobox emits the typed text on every keystroke.
        this.advancedSearchItems.model = null;
      } else if (value) {
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the versions if we are searching for a license plate.
        if (this.loadingPlate === false)
          this.getVersions(value.brandCode, value.modelCode);
        this.advancedSearchItems.model = value.modelCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.advancedSearchItems.model = null;
      }
    },
    version(value) {
      if (typeof value === "string") {
        this.advancedSearchItems.version = null;
      } else if (value) {
        this.advancedSearchItems.version = value.versionCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.advancedSearchItems.version = null;
      }
    },
    engine(value) {
      if (!value) {
        if (this.model && this.model.modelCode) {
          this.getVersions(this.model.brandCode, this.model.modelCode);
        }
        return;
      }
      this.versions = this.versions.filter((v) => v.engineCode === value);
    },

    year(value) {
      if (value) {
        this.$refs.form.validate();
        // filter models
        if (value.length === 4) {
          // Filter only when year is valid (4 characters long)
          this.filterModels();
          this.filterVersions();
        } else if (value.length !== 4 && this.brand && this.brand.brandCode) {
          // Reset models.
          this.getModels(this.brand.brandCode);
        }
      }
    },

    supply(value) {
      if (value) {
        this.filterVersions();
      } else if (
        !value &&
        this.brand &&
        this.brand.brandCode &&
        this.model &&
        this.model.modelCode
      ) {
        // reset versions.
        this.getVersions(this.brand.brandCode, this.model.modelCode);
      }
    },
    "$i18n.locale"() {
      this.getLocale();
    },
  },
  mounted() {
    this.getLocale();
    // Set initial year rule.
    this.setYearRule();
    if (this.$store.getters.userId) {
      this.getLogs(this.$store.getters.userId);
    }
  },
  methods: {
    getLogs(userId) {
      getRequest(`/plate-logs/${userId}`)
        .then((res) => {
          if (res && res.logs) {
            this.logs = res.logs;
            this.logsCount = res.log_count || 0;

            // ✅ prepare autocomplete suggestions here
            const sorted = [...this.logs].sort(
              (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
            );

            this.lastFivePlates = [
              ...new Set(sorted.map((l) => l.plate)),
            ].slice(0, 5);
          }
        })
        .catch(() => {});
    },
    getLocale() {
      this.searchTypes[0].label = this.$t("parts.damaged_parts.title");
      this.searchTypes[1].label = this.$t(
        "parts.damaged_parts.multiple_titles",
      );
      this.searchTypes[2].label = this.$t("parts.damaged_parts.id");
      this.searchTypes[3].label = this.$t("parts.damaged_parts.other");
      this.statusItems[0].title = this.$t("parts.status.damaged_inventory");
      this.statusItems[1].title = this.$t("parts.status.damaged_sales");
      this.statusItems[2].title = this.$t("parts.status.damaged_shop");
      this.statusItems[3].title = this.$t("parts.status.damaged_lost");
      this.supplies[0].title = this.$t("parts.advanced_search.supply.petrol");
      this.supplies[1].title = this.$t("parts.advanced_search.supply.diesel");
      this.supplies[2].title = this.$t("parts.advanced_search.supply.gas");
    },
    formatDateToDisplay(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 0-indexed
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    onGroupSelected(group) {
      if (group) {
        this.titleCodes = group.codes || [];
        this.selectingItemCodes = true;

        this.$nextTick(() => {
          setTimeout(() => {
            this.menuMultipleOpen = false;
          }, 100);
          this.searchMethod();
        });
      } else {
        this.titleCodes = [];
      }
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
    setYearRule(startingDate, endingDate) {
      const startingYear = startingDate
        ? new Date(startingDate).getFullYear()
        : 1900;
      const endingYear = endingDate
        ? new Date(endingDate).getFullYear()
        : new Date().getFullYear();
      this.yearRule = (v) =>
        (v >= startingYear && v <= endingYear) ||
        this.$t("parts.advanced_search.year_error");
    },
    searchMethod() {
      if (this.advancedSearch) {
        if (this.advancedSearchItems.startDate) {
          this.advancedSearchItems.startDate = this.formatDateToDisplay(
            this.advancedSearchItems.startDate,
          );
        }
        if (this.advancedSearchItems.endDate) {
          this.advancedSearchItems.endDate = this.formatDateToDisplay(
            this.advancedSearchItems.endDate,
          );
        }
        // ADVANCED SEARCH
        this.$emit("adv-search", {
          type: this.searchType,
          searchField: this.search,
          titleCode: this.titleCode,
          titleCodes: this.titleCodes,
          advancedSearchFields: this.advancedSearchItems,
        });
      } else if (
        this.search.length > 0 ||
        this.titleCode ||
        (this.titleCodes && this.titleCodes.length)
      ) {
        // REGULAR SEARCH
        this.$emit("search", {
          type: this.searchType,
          searchField: this.search,
          titleCode: this.titleCode,
          titleCodes: this.titleCodes,
        });
      }
      this.menuOpen = false;
      this.menuMultipleOpen = false;
    },
    onQualityRatingSelect(val) {
      if (this.selectedQualityRating === val || val === 0) {
        this.selectedQualityRating = 0;
        this.advancedSearchItems.quality = this.qualityItems.map((q) => q._id);
      } else {
        this.selectedQualityRating = val;
        const matches = this.qualityItems
          .filter((q) => q.rating === val)
          .map((q) => q._id);
        this.advancedSearchItems.quality = matches.length
          ? matches
          : this.qualityItems.map((q) => q._id);
      }
    },
    clearSearchFields() {
      this.search = "";
      this.titleCode = null;
      this.advancedSearchItems = {
        brand: null,
        model: null,
        version: null,
        institution: null,
        shipment: null,
        status: [7, 8, 8.1, 9],
        quality: [],
        price: [0, 50000],
        startDate: "",
        endDate: "",
      };
      this.year = null;
      this.supply = null;
      this.plate = null;
      this.brand = null;
      this.model = null;
      this.version = null;
      this.engine = null;
      this.models = [];
      this.versions = [];
      this.qualityItems.forEach((quality) =>
        this.advancedSearchItems.quality.push(quality._id),
      );
      this.selectedQualityRating = 0;
      this.$emit("clear-search");
    },

    getBrands() {
      this.loadingBrand = true;
      getRequest("/info-car/brands")
        .then((response) => {
          this.brands = response.brands;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getModels(brandCode) {
      this.loadingModel = true;
      getRequest("/info-car/models", `brand_code=${brandCode}`)
        .then((response) => {
          this.models = response.models;
          this.filterModels();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingModel = false;
        });
    },
    getVersions(brandCode, modelCode) {
      this.loadingVersion = true;
      getRequest(
        "/info-car/versions",
        `brand_code=${brandCode}&model_code=${modelCode}`,
      )
        .then((response) => {
          this.versions = response.versions;
          this.filterVersions();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingVersion = false;
        });
    },

    filterModels() {
      if (
        this.year &&
        this.year.length === 4 &&
        this.models &&
        this.models.length > 0
      ) {
        this.models = this.models.filter((model) => {
          const sYear = model.startingDate
            ? new Date(model.startingDate).getFullYear()
            : 1900;
          const eYear = model.endingDate
            ? new Date(model.endingDate).getFullYear()
            : new Date().getFullYear();

          return this.year >= sYear && this.year <= eYear;
        });
      }
    },
    filterVersions() {
      if (
        this.brand &&
        this.brand.brandCode &&
        this.model &&
        this.model.modelCode &&
        this.versions &&
        this.versions.length > 0
      ) {
        if (this.year) {
          // filter by year
          this.versions = this.versions.filter((version) => {
            const sYear = version.startingDate
              ? new Date(version.startingDate).getFullYear()
              : 1900;
            const eYear = version.endingDate
              ? new Date(version.endingDate).getFullYear()
              : new Date().getFullYear();

            return this.year >= sYear && this.year <= eYear;
          });
        }

        if (this.supply) {
          // filter by supply
          this.versions = this.versions.filter(
            (version) => version.supplyCode === this.supply,
          );
        }
      }
    },
    async exportToExcel() {
      const data = await this.exportData();

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Damaged");

      // Trigger download
      XLSX.writeFile(wb, "damaged.xlsx");
    },
    exportData() {
      const items = [];
      this.$props.items.forEach((item) => {
        const itemObject = {
          Status:
            item.status === 7
              ? "Damaged-Inventory"
              : item.status === 8
                ? "Damaged-Sales"
                : item.status === 8.1
                  ? "Damaged-Shop"
                  : item.status === 9
                    ? "Damaged-Lost"
                    : "",
          ID: item.old_id ? item.old_id : item._id,
          Title: item.title,
          "Manufacturer Code": item.manufacturer_code,
          Notes: item.notes,
          Quality: item.quality.title,
          Location:
            item.shelf_id && item.shelf_data
              ? `${item.shelf_data.shelf.room_name}-${item.shelf_data.shelf.location_code}: ${
                  item.shelf_data.shelf.x
                }, ${item.shelf_data.shelf.y}`
              : "",
          Price: `${item.price} ${item.currency}`,
          "Date Created": moment(item.date_created).format("DD-MM-YYYY LT"),
        };
        items.push(itemObject);
      });
      return items;
    },
    getQualities() {
      this.loadingQuality = true;
      getRequest("/quality/")
        .then((response) => {
          this.qualityItems = response.qualities;
          this.advancedSearchItems.quality = [];
          this.qualityItems.forEach((quality) =>
            this.advancedSearchItems.quality.push(quality._id),
          );
          this.loadingQuality = false;
        })
        .catch(() => {
          this.loadingQuality = false;
        });
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
    getInstitution() {
      getRequest("/institution", `id=${this.$store.getters.institutionId}`)
        .then((response) => {
          if (response.institution && response.institution.length > 0) {
            this.canSearchPlates = !!(
              response.institution[0].plates.remaining > 0
            );
          }
        })
        .catch(() => {});
    },
    getShipments(institutionId) {
      this.loadingShipment = true;
      getRequest("/shipment/institution", `id=${institutionId}`)
        .then((response) => {
          this.shipments = response.shipments;
          this.loadingShipment = false;
        })
        .catch(() => {
          this.loadingShipment = false;
        });
    },
    searchPlate() {
      if (this.plate && this.plate.length > 0) {
        this.loadingPlate = true;
        getRequest(`/info-car/plate/${this.plate}`, "")
          .then(async (response) => {
            try {
              const { brands } = await getRequest("/info-car/brands");
              this.brands = brands;
              this.brand = await getRequest(
                "/info-car/brand",
                `id=${response.brandId}`,
              );

              const { models } = await getRequest(
                "/info-car/models",
                `brand_code=${response.brandCode}`,
              );
              this.models = models;
              this.model = await getRequest(
                "/info-car/model",
                `id=${response.modelId}`,
              );

              const { versions } = await getRequest(
                "/info-car/versions",
                `brand_code=${response.brandCode}&model_code=${response.modelCode}`,
              );
              this.versions = versions;
              this.version = await getRequest(
                "/info-car/version",
                `id=${response.versionId}`,
              );

              this.foundPlate = true;
              let data = {
                user_id: this.$store.getters.userId,
                plate: this.plate.toUpperCase(),
              };
              postRequest
                .object(`/plate-logs`, data)
                .then(() => {
                  // console.log('res',res)
                })
                .catch(() => {});
              this.getInstitution();
            } catch (error) {
              this.$emit("alert", {
                message: this.$t("parts.advanced_search.plate_not_found"),
                type: "error",
                timeout: 5000,
              });
              this.foundPlate = false;
            }
          })
          .catch((error) => {
            this.$emit("alert", {
              message: this.$t("parts.advanced_search.plate_not_found"),
              type: "error",
              timeout: 5000,
            });
            this.foundPlate = false;
          })
          .finally(() => {
            this.loadingPlate = false;
          });
      }
    },
    setId(id) {
      this.searchType = "id";
      this.search = id;
    },
    highlight(title, search) {
      let result = title || "";
      if (search) {
        const index = title
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase());
        // mark the text.
        if (index > -1)
          result = [
            title.slice(0, index),
            "<mark>",
            title.slice(index, index + search.length),
            "</mark>",
            title.slice(index + search.length),
          ].join("");
      }
      return `<span>${result}</span>`;
    },
    customFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const searchText = queryText.toLowerCase();
      const language = this.$store.getters.language;

      // Check main title
      const mainTitle = itemText.raw?.title?.[language]?.toLowerCase() || "";
      if (mainTitle.includes(searchText)) return true;

      // Check related titles
      const relatedTitles = itemText.raw?.related || [];
      return relatedTitles.some((related) => {
        const relatedTitle = related?.title?.[language]?.toLowerCase() || "";
        return relatedTitle.includes(searchText);
      });
    },
    updateSearch(value) {
      this.searchTitle = value;
    },
    selectCode(item) {
      this.titleCode = item.raw?.partCode || item.partCode || item.value;
      this.selectingItem = true;
      this.$nextTick(() => {
        this.searchMethod();
      });
    },
    selectPlate(p) {
      this.plate = p;
      this.showDropdown = false;
      this.searchPlate();
    },
    onBlur() {
      // Delay hiding dropdown to allow click on item
      setTimeout(() => {
        this.showDropdown = false;
      }, 100);
    },
  },
};
</script>
<style scoped>
.related-scroll {
  overflow-x: auto;
  white-space: nowrap;
  margin-top: -8px;
  max-width: 400px;
}

.related-scroll span {
  white-space: nowrap;
}

/* Top search strip (mirrors Inventory toolbar behavior) */
.damaged-toolbar-strip {
  position: relative;
  z-index: 1;
  width: 100%;
}

.damaged-toolbar-root .min-width-0 {
  min-width: 0;
}

.damaged-toolbar-root :deep(.damaged-field-on-red .v-field) {
  min-width: 0;
}

@media (min-width: 960px) {
  .damaged-toolbar-root .damaged-toolbar-right {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
  }

  .damaged-toolbar-root .damaged-toolbar-search-row {
    align-items: center;
  }

  .damaged-toolbar-root .damaged-toolbar-brand {
    max-width: min(38vw, 26rem);
  }
}

.damaged-toolbar-root .damaged-toolbar-type-select {
  width: min(100%, 11rem);
}

@media (min-width: 960px) {
  .damaged-toolbar-root .damaged-toolbar-type-select {
    width: 9.25rem;
  }
}

/* Model/version combobox mobile layout */
@media (max-width: 959px) {
  .damaged-toolbar-root .car-version-detail-selection {
    width: 100%;
    padding: 0.375rem 0.25rem;
  }

  .damaged-toolbar-root .car-version-detail-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    gap: 0.75rem 1rem;
  }

  .damaged-toolbar-root .car-version-detail-col {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
    flex: 1 1 0;
  }

  .damaged-toolbar-root .car-version-detail-col .caption {
    line-height: 1.25;
    margin-bottom: 0.125rem;
  }

  .damaged-toolbar-root .car-version-detail-col .font-weight-bold {
    line-height: 1.4;
    word-break: break-word;
  }

  .damaged-toolbar-root .car-search-combobox :deep(.v-field) {
    --v-field-padding-top: 10px;
    --v-field-padding-bottom: 10px;
    height: auto !important;
    min-height: 3.5rem;
  }

  .damaged-toolbar-root .car-search-version-combobox :deep(.v-field) {
    --v-field-padding-top: 12px;
    --v-field-padding-bottom: 12px;
    min-height: 4.5rem;
  }

  .damaged-toolbar-root .car-search-combobox :deep(.v-field__field) {
    height: auto !important;
    min-height: 3.5rem;
    align-items: flex-start;
  }

  .damaged-toolbar-root .car-search-version-combobox :deep(.v-field__field) {
    min-height: 4.5rem;
  }

  .damaged-toolbar-root .car-search-combobox :deep(.v-field__input) {
    white-space: normal;
    overflow: visible;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: unset;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .damaged-toolbar-root .car-search-version-combobox :deep(.v-field__input) {
    display: block !important;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .damaged-toolbar-root .car-search-combobox :deep(.v-combobox__selection) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    width: 100%;
    max-width: 100%;
  }

  .damaged-toolbar-root .car-search-version-combobox :deep(.v-combobox__selection) {
    display: block !important;
    width: 100%;
    position: static !important;
    transform: none !important;
  }

  .damaged-toolbar-root .car-detail-selection {
    overflow: visible;
    width: 100%;
  }


  .damaged-toolbar-root .car-version-detail-row,
  .damaged-toolbar-root .car-version-detail-row--dropdown {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem 0.875rem;
    flex-wrap: unset;
  }

  .damaged-toolbar-root .car-version-detail-col {
    flex: unset;
    padding: 0;
  }

  .damaged-toolbar-root .car-version-detail-col--main {
    grid-column: 1 / -1;
    padding-bottom: 0.625rem;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .damaged-toolbar-root .car-version-detail-col--main .font-weight-bold {
    line-height: 1.45;
  }

  .damaged-toolbar-root .car-detail-col {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: none;
    min-width: 0;
    padding: 0;
    word-break: break-word;
  }

  .damaged-toolbar-root .car-detail-selection.d-flex {
    flex-wrap: wrap;
    gap: 0.625rem 0.75rem;
  }
}

/* Advanced search panel */
.damaged-advanced-search-panel {
  overflow-x: hidden;
}

.damaged-toolbar-root .damaged-advanced-divider-row {
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 0.25rem;
}

.damaged-toolbar-root .damaged-advanced-divider-label {
  white-space: normal;
  line-height: 1.3;
  width: 100%;
  max-width: 100%;
}

@media (min-width: 600px) {
  .damaged-toolbar-root .damaged-advanced-divider-row {
    flex-wrap: nowrap;
  }

  .damaged-toolbar-root .damaged-advanced-divider-label {
    white-space: nowrap;
    width: auto;
  }
}
</style>
